export enum ZciNavigationItemId {
    OWN_ACCOUNTS = 'OWN_ACCOUNTS',
    OBSERVABLE_ACCOUNTS = 'OBSERVABLE_ACCOUNTS',
    USERS = 'USERS',
}
